module.exports = __webpack_public_path__ + "static/media/G1-29-Thea-Persayious-cod60.3d763127.png";